import { render, staticRenderFns } from "./SalesTemplateYearly.vue?vue&type=template&id=875dae84&scoped=true"
import script from "./SalesTemplateYearly.vue?vue&type=script&lang=js"
export * from "./SalesTemplateYearly.vue?vue&type=script&lang=js"
import style0 from "./SalesTemplateYearly.vue?vue&type=style&index=0&id=875dae84&prod&scoped=true&scss=lang&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875dae84",
  null
  
)

export default component.exports